// Model.js
// -----------------------
// @module Case
define("NVT.membershipdirectory.membershipdirectory.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/membershipdirectory/SuiteScript2/membershipdirectory.Service.ss"
            ),
            true
        )
});
});
